module.exports = __webpack_public_path__ + "img/success.60bf9484.gif";